import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { XIcon } from "lucide-react";
import { Dialog } from "radix-ui";
import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

import { DialogOverlay } from "./DialogOverlay";
import { DialogPortal } from "./DialogPortal";

type DialogContentProps = ComponentProps<typeof Dialog.Content> & {
  showCloseButton?: boolean;
};

export const DialogContent = ({
  className,
  children,
  showCloseButton = true,
  ...props
}: DialogContentProps) => {
  const { _ } = useLingui();
  return (
    <DialogPortal>
      <DialogOverlay />
      <Dialog.Content
        data-slot="dialog-content"
        className={cn(
          "fixed top-1/2 left-1/2 z-50 grid w-full max-w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 gap-4 rounded-lg border border-border bg-surface p-6 text-foreground shadow-lg duration-200 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 sm:max-w-lg",
          className,
        )}
        {...props}
      >
        {children}
        {showCloseButton && (
          <Dialog.Close
            data-slot="dialog-close"
            aria-label={_(msg`Close`)}
            className="absolute top-4 right-4 rounded-sm text-muted transition-colors outline-none hover:text-foreground focus-visible:ring-2 focus-visible:ring-accent/60 [&_svg]:size-4"
          >
            <XIcon aria-hidden="true" />
          </Dialog.Close>
        )}
      </Dialog.Content>
    </DialogPortal>
  );
};
